<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>151 - Подогрев  (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >

        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr class="header-row-success">
              <th  class="title-cell" rowspan="3">Наименование месяца </th>
              <th rowspan="3">Единица измерения</th>
              <th rowspan="3">Общ. площадь здания</th>
              <th colspan="12">Электроэнергия</th>
            </tr>
            <tr class="header-row-success">
              <th rowspan="2">Количество всего потребления </th>
              <th colspan="3">в том числе от зависим.потребления </th>
              <th rowspan="2">Средняя стоимость тарифа </th>
              <th colspan="3">в том числе от зависим.потребления </th>
              <th rowspan="2">Общая стоимость</th>
              <th colspan="3">в том числе от зависим.потребления </th>
            </tr>
            <tr class="header-row-success">
              <th>Потреб. 1</th>
              <th>Потреб. 2</th>
              <th>Потреб. 3</th>
              <th>Тариф 1</th>
              <th>Тариф 2</th>
              <th>Тариф 3</th>
              <th>Итого 1</th>
              <th>Итого 2</th>
              <th>Итого 3</th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
               <td></td>
              <td></td>
              <td>{{ dto.totalExpense }}</td>
              <td>{{ dto.expense1 }}</td>
              <td>{{ dto.expense2 }}</td>
              <td>{{ dto.expense3 }}</td>
              <td>{{ dto.avgTariff }}</td>
              <td>{{ dto.tariff1 }}</td>
              <td>{{ dto.tariff2 }}</td>
              <td>{{ dto.tariff3 }}</td>
              <td>{{ dto.totalCost }}</td>
              <td>{{ dto.cost1 }}</td>
              <td>{{ dto.cost2 }}</td>
              <td>{{ dto.cost3 }}</td>
            </tr>

            <tr v-for="month in dto.months">
              <td>
                {{ months[month.month - 1] }}
              </td>
              <td>куб.метр</td>
              <td class="expense-sum-edit">
                <el-input v-model="month.heatingArea" type="number" @input="recalculate( 'heatingArea',  month)"/>
              </td>
              <td>{{month.totalExpense}}</td>
              <td class="expense-sum-edit">
                <el-input v-model="month.expense1" type="number" @input="recalculate( 'expense1',  month)"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="month.expense2" type="number" @input="recalculate( 'expense2', month)"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="month.expense3" type="number" @input="recalculate( 'expense3', month)"/>
              </td>

              <td>{{month.avgTariff}}</td>
              <td class="expense-sum-edit">
                <el-input v-model="month.tariff1" type="number" @input="recalculate( 'tariff1', month)"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="month.tariff2" type="number" @input="recalculate( 'tariff2', month)"/>
              </td>
              <td class="expense-sum-edit">
                <el-input v-model="month.tariff3" type="number" @input="recalculate( 'tariff3', month)"/>
              </td>

              <td>{{month.totalCost}}</td>
              <td>{{month.cost1}}</td>
              <td>{{month.cost2}}</td>
              <td>{{month.cost3}}</td>

            </tr>

            </tbody>
          </table>
        </div>


      </form>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'water-heating',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        months: [],
      },
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },

    async findById(uuid) {
      this.isLoading = true;
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.sortByCatAndMonth();
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.sortByCatAndMonth();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    sortByCatAndMonth() {
      if (!this.dto.months) {
        return;
      }
      this.dto.months.sort((a, b) => a.month - b.month);


        this.dto.months.forEach(month => {
          this.recalculate('tariff1',  month);
          this.recalculate('tariff3', month);
          this.recalculate('tariff2', month);
          this.recalculate('expense1', month);
          this.recalculate('expense2', month);
          this.recalculate('expense3', month);
        });

    },

    goBack()  {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED'  || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },

    recalculate(fieldName, month) {
      if (!this.dto.months) {
        return;
      }

      if (month) {
        if (fieldName.includes('tarif')) {
          let count = 0, sum = 0;
          ['tariff1', 'tariff2', 'tariff3'].forEach(t => {
            if (month[t] && month[t] > 0) {
              sum += parseFloat(month[t]);
              count++;
            }
          });
          month.avgTariff = count > 0? (sum / count).toFixed(2) : 0;
          this.dto['avgTariff'] = this.dto.months.reduce((sum, c) => sum + parseFloat(c['avgTariff'] || 0), 0).toFixed(2);
        }   else if (fieldName.includes('expense')) {
          month.totalExpense = parseFloat(month.expense1 || 0) +
              parseFloat(month.expense2 || 0) +
              parseFloat(month.expense3 || 0);
          this.dto['totalExpense'] = this.dto.months.reduce((sum, c) => sum + parseFloat(c['totalExpense'] || 0), 0);
        }
        month.cost1 = (parseFloat(month.expense1 || 0) * parseFloat(month.tariff1 || 0)).toFixed(2);
        month.cost2 = (parseFloat(month.expense2 || 0) * parseFloat(month.tariff2 || 0)).toFixed(2);
        month.cost3 = (parseFloat(month.expense3 || 0) * parseFloat(month.tariff3 || 0)).toFixed(2)
        month.totalCost = parseFloat(month.cost1 || 0) + parseFloat(month.cost2 || 0) + parseFloat(month.cost3 || 0);
      }


      this.dto['totalCost'] = this.dto.months.reduce((sum, c) => sum + parseFloat(c['totalCost'] || 0), 0);
      this.dto[fieldName] = this.dto.months.reduce((sum, c) => sum + parseFloat(c[fieldName] || 0), 0);

     }


  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 350px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; }
.total-row td {
  font-weight: bold;
}
.header-row-success th { background-color: #d4edda !important; }
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type=number] {
  -moz-appearance: textfield;
}
</style>
